import { EphattaRouteProps } from "@components/root";
import { atom } from "recoil";


export const RoutesState = atom<Array<EphattaRouteProps>>({
    key: 'state.Routes',
    default : undefined
});
